import React, { useEffect, useMemo, useRef } from 'react'
import { message } from 'antd'
import request from '../../../utils/request'
import * as useAuth from '../../../utils/auth'
import messageSuccess from '../../collect/messageSuccess'
import ModalConfirm from '../../modal/modalConfirm'
import TreeOption from '../../inspirationTreeList'
import { addToIdeaMass, removeToIdeaMass } from '../common'
import RightRenderTab from '../rightRenderTab'
import { queryTypeList } from '../enum'

export default ({
  clearAction,
  data,
  queryType,
  onChangeTab,
  treeData,
  selectIds,
  setSelectIds,
  selectItems,
  setSelectItems,
  //
  blogList: wrapBlogList,
  formParams,
  currentViewBlog,
  batchSelected,
  saveImgUrlList,
  batchAddTag,
  //
  onAssociateTask,
  afterJoin,
  onClose,
  //
  singleCollection,
  onInit,
  loading,
  keyWords,
  onKeyWords,
  onLoad,
  onUpdateInspiration
}) => {
  const _formParams = useMemo(() => {
    return {
      ...formParams,
      tagNameList: Array.from(formParams.tags)
    }
  }, [formParams])

  const blogList = useMemo(() => {
    if (formParams.styleTitle) {
      return wrapBlogList?.map(item => ({ ...item, styleTitle: null })) || []
    }
    return wrapBlogList
  }, [wrapBlogList, formParams])

  const onTreeChange = (checked, currentItem) => {
    if (checked) {
      treeData.checkSelectMarkStatus(currentItem)
      selectItems.push(currentItem)
      selectIds.push(currentItem.value)
    } else {
      treeData.checkNoSelectMarkStatus(currentItem)
      const _findIndex = selectIds.findIndex(i => i === currentItem.value)
      const _currentFindIndex = selectItems.findIndex(i => i.value === currentItem.value)
      selectItems.splice(_currentFindIndex, 1)
      selectIds.splice(_findIndex, 1)
    }
    treeData.controlQuantity(checked, currentItem)
    setSelectIds(pre => [...pre])
    setSelectItems(pre => [...pre])
  }

  // 创建新灵感集时，自动将当前博客加入灵感集
  const onCreateInspiration = async (inspirationId, inspirationName, newInspirationData) => {
    const { itemOriginDTO } = currentViewBlog
    if (batchSelected?.length) {
      batchAddTag()
    }
    if (!singleCollection) {
      selectIds.push(inspirationId)
      selectItems.push(newInspirationData)
      onInit()
      return
    }
    if (blogList.map(item => item?.blogId).filter(Boolean).length) {
      const defaultParams = {
        inspirationId,
        blogList,
        itemOriginDTO,
        ..._formParams,
      }
      const _params = blogList.length > 1 ? defaultParams : { ...defaultParams, saveImgUrlList }
      addToIdeaMass(_params).then(res => {
        if (!res) return
        onClose()
        afterJoin?.({
          collectIdList: res.collectIdList,
          name: inspirationName,
          data: res,
          params: _params,
        })
        messageSuccess({
          collectIdList: res.collectIdList,
          name: inspirationName,
          loginUserInfo: res.loginUserInfo,
          data: res,
        })
      })
    } else { // 没有blogId 走上传逻辑
      uploadIns([newInspirationData])
    }
  }

  const beforeJoin = async (inspiration) => {
    if (batchSelected?.length) { // 批量采集添加标签 //暂时不知道多选灵感集的批量添加标签如何
      batchAddTag()
    }
    const inspirationList = Array.isArray(inspiration) ? inspiration : [inspiration]
    const res = await request.post('/ins/inspiration/calculate-no-collect-num', {
      blogList,
      inspirationIdList: inspirationList.map(item => item.id),
      itemOriginDTO: currentViewBlog.itemOriginDTO,
      ..._formParams,
    })
    // 灵感集数量*款式数量-已存在的数量
    const joinNum = blogList.length * inspirationList.length
    if (res && res !== joinNum) {
      ModalConfirm.show({
        title: '采集提示',
        content: `${joinNum - res}个款式已在灵感集 ${inspirationList.map(item => item.name).join(',')} 中存在，将采集剩余${res}个款式。`,
        onOk: () => toggleJoin(inspirationList),
      })
      return
    }
    toggleJoin(inspirationList)
  }

  const toggleJoin = async (inspirationList) => { //
    if (blogList.map(item => item?.blogId).filter(Boolean).length) {
      const defaultParams = {
        blogList,
        inspirationIdList: inspirationList.map(item => item.id),
        itemOriginDTO: currentViewBlog.itemOriginDTO,
        ..._formParams,
      }
      const _params = blogList.length > 1 ? defaultParams : { ...defaultParams, saveImgUrlList }
      const res = await addToIdeaMass(_params)
      if (res.errorCode === 'MEINIAN_MEAL_AUTH_ERROR_0019') {
        message.error('由于团队版本降级，您需要先前往美念选择需要保留的灵感集。')
        return
      }
      if (res?.errorCode === 'INS0029') { // 单独处理该错误消息
        message.error(res.errorDesc)
        return
      }
      const inspiration = inspirationList[0]
      messageSuccess({
        collectIdList: res.collectIdList,
        name: inspiration?.name,
        inspirationList,
        loginUserInfo: res.loginUserInfo,
        data: res,
        firstData: inspiration
      })
      if (inspirationList.length === 1 && res?.effectTargetNum && useAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) && res.collectIdList?.length <= 1) {
        onAssociateTask?.({
          inspiration, inspirationId: inspiration.id, res, collectIdList: res.collectIdList, loginUserInfo: res.loginUserInfo })
      }
      onClose?.()
      afterJoin?.({
        collectIdList: res.collectIdList,
        name: inspiration?.name,
        data: res,
        firstData: inspiration,
        params: _params,
      })
    } else { // 没有blogId 走上传逻辑
      uploadIns(inspirationList)
    }
  }

  const uploadIns = async (inspirationList) => {
    // 采集出现错误时转为上传采集
    try {
      const itemList = [{
        mainUrl: currentViewBlog.mainUrl || currentViewBlog.picUrl,
      }]
      const _params = {
        inspirationIdList: inspirationList.map(item => item.id),
        itemList,
        ..._formParams,
        title: ''
      }
      const res = await request.post('/zhikuan/user-img/upload-img', _params)
      const inspiration = inspirationList[0]
      messageSuccess({
        collectIdList: res.collectIdList,
        loginUserInfo: res.loginUserInfo,
        inspirationList,
        name: inspiration.name,
        data: res,
        firstData: inspiration
      })
      // 选款任务不在多选的时候展示
      if (inspirationList.length === 1 && res?.effectTargetNum && useAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) && res.collectIdList?.length <= 1) {
        onAssociateTask?.({ inspiration, inspirationId: inspiration.id, res, collectIdList: res.collectIdList, loginUserInfo: res.loginUserInfo })
      }
      onClose()
      afterJoin?.({
        collectIdList: res.collectIdList,
        name: inspiration.name,
        data: res,
        firstData: inspiration,
        params: _params,
      })
    } catch (err) {
      message.error(err.errorDesc || err)
    }
  }

  const onCancelCollect = async (inspirationId, currentItem) => {
    treeData.checkNoSelectMarkStatus(currentItem)
    const defaultParams = {
      blogList,
      inspirationId,
    }
    const _params = defaultParams
    await removeToIdeaMass(_params)
    onInit()
  }

  const onItemCollect = async (inspirationId, inspiration) => { // 列表item采集
    if (onUpdateInspiration) {
      await onUpdateInspiration(inspirationId, inspiration)
      onClose?.()
    } else {
      await beforeJoin(inspiration)
    }
  }
  const treeOptionRef = useRef(null)
  useEffect(() => {
    treeOptionRef.current?.onClear()
  }, [clearAction])

  return <TreeOption
    onLoad={onLoad}
    keyWords={keyWords}
    onKeyWords={onKeyWords}
    hasCollectChange={!blogList.length > 1}
    ref={treeOptionRef}
    blogList={blogList} // 代表多选
    loading={loading}
    onCancel={onClose}
    collectBtnDisabled={!selectItems.length}
    onOk={async () => { // 底部采集
      const _selectItems = selectItems.map(item => ({ ...item, currentCollectFlag: 1 }))
      if (onUpdateInspiration) {
        await onUpdateInspiration(_selectItems)
        onClose?.()
      } else {
        beforeJoin(_selectItems)
      }
    }}
    singleCollection={singleCollection}
    onCancelCollect={onCancelCollect}
    onItemCollect={onItemCollect}
    treeData={treeData}
    tabOptionHead={queryTypeList.find(item => queryType === item.value)}
    renderTab={() => <RightRenderTab value={queryType} onChange={onChangeTab} data={data} />}
    data={data}
    scrollHeight={396}
    listWidth={463}
    value={selectIds}
    onChooseTaskClose={() => onClose()}
    onChooseTaskOk={() => onClose()}
    onCreateInspiration={onCreateInspiration}
    onChange={onTreeChange}
  />
}
